<template>
  <div class="logo-uploader">
    <label class="logo-drop" :class="{ 'has-logo': shownLogo }">
      <input type="file" accept="image/*" @change="handleFile" />

      <template v-if="shownLogo">
        <img :src="shownLogo" alt="Company logo" />
        <span class="replace-label">Change logo</span>
      </template>

      <template v-else>
        <div class="upload-icon" aria-hidden="true">↑</div>
        <strong>Company Logo</strong>
        <span>Upload image</span>
      </template>
    </label>
  </div>
</template>

<script setup lang="ts">
import { computed, onBeforeUnmount, ref } from 'vue'

const props = defineProps<{ existing?: string | null }>()
const emit = defineEmits<{ (e: 'file', file: File | null): void }>()

const preview = ref<string | null>(null)
let objectUrl: string | null = null

const shownLogo = computed(() => preview.value || props.existing || null)

function handleFile(event: Event) {
  const file = (event.target as HTMLInputElement).files?.[0] ?? null
  emit('file', file)

  if (objectUrl) URL.revokeObjectURL(objectUrl)
  objectUrl = file ? URL.createObjectURL(file) : null
  preview.value = objectUrl
}

onBeforeUnmount(() => {
  if (objectUrl) URL.revokeObjectURL(objectUrl)
})
</script>

<style scoped>
.logo-uploader {
  min-height: 120px;
}

.logo-drop {
  height: 118px;
  border: 2px dashed #8c99a8;
  border-radius: 50%;
  aspect-ratio: 1.55 / 1;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  cursor: pointer;
  overflow: hidden;
  position: relative;
  background: rgba(255, 255, 255, .34);
  color: #42536a;
}

.logo-drop input {
  position: absolute;
  opacity: 0;
  pointer-events: none;
}

.logo-drop img {
  width: 86%;
  height: 86%;
  object-fit: contain;
}

.logo-drop strong { font-size: 14px; }
.logo-drop span { font-size: 11px; }

.upload-icon {
  font-size: 24px;
  line-height: 1;
  margin-bottom: 4px;
}

.replace-label {
  position: absolute;
  bottom: 4px;
  background: rgba(237, 241, 244, .9);
  padding: 1px 7px;
  border-radius: 99px;
}
</style>
